import { inject, observer, Provider } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import initBrowserStores from '../../../browser/initBrowserStores';
import BrowserStore from '../../../browser/stores/BrowserStore';
import CustomizeUIStore from '../../../stores/CustomizeUI/CustomizeUIStore';
import FlagStore from '../../../stores/FlagStore';
import TopBarAlternative from '../../TopBarAlternative/TopBarAlternative';

const trueStore = new FlagStore(true, () => null);
const falseStore = new FlagStore(false, () => null);

class BaseBrowserPreview extends Component {
    static propTypes = {
        customizeUI: CustomizeUIStore.PropType,
        withStores: PropTypes.func,
    };

    static defaultProps = {
        withStores: (s) => s,
    };

    stores = null;

    state = {
        storesKey: null,
    };

    setStores = (isInit) => {
        const { browserStoresInitStatus } = this.props.customizeUI;
        if (browserStoresInitStatus.successCount !== this.state.storesKey) {
            this.stores = this.props.withStores(initBrowserStores({
                browser: {
                    ...(this.props.customizeUI.browserStoresInitStatus?.result?.browser ?? {}),
                    topBarUnpinned: falseStore,
                    topBarNeedsMinimization: falseStore,
                    canExitIsolation: () => true,
                    blockAdsByDefault: true,
                    showNotification: () => null,
                    closeNotification: () => null,
                    isTopBarMinificationAllowed: () => false,
                    topBarMenu: falseStore,
                    adBlock: trueStore,
                    adBlockModal: falseStore,
                    isConsolePreview: true,
                    pageStatus: BrowserStore.PAGE_STATUS.SECURE_SITE,
                    isHomePage: false,
                    notification: null,
                    navigateToUrl: () => null,
                },
                env: {
                    ...(browserStoresInitStatus?.result?.env ?? {}),
                    screenWidthOffset: 394,
                },
            }, false));

            if (this.stores.env.isUrlIsolation) {
                this.stores.browser.urlInputValue = 'https://urlisolation.com';
            } else if (this.stores.env.isSaasIsolation) {
                this.stores.browser.urlInputValue = 'https://saasisolation.com';
            } else {
                this.stores.browser.urlInputValue = 'https://proofpointisolation.com';
            }

            if (isInit) {
                this.state.storesKey = browserStoresInitStatus.successCount;
            } else {
                this.setState({ storesKey: browserStoresInitStatus.successCount });
            }
        }

        window.PREVIEW_STATE = this.stores;
    };

    constructor(props) {
        super(props);
        this.setStores(true);
    }

    componentDidUpdate() {
        this.setStores();
    }

    render() {
        return <div
            style={{
                minHeight: 250,
                background: this.stores.browser.notification ? '#00000061' : 'none',
            }}
            key={this.state.storesKey}
        >
            <Provider {...this.stores}>
                <TopBarAlternative />
            </Provider>
            {this.props.children ? <div style={{ padding: 20, border: '1px solid #00000024', borderTop: '0 none' }}>
                {this.props.children}
            </div> : null}
        </div>;
    }
}

export default inject('customizeUI')(observer(BaseBrowserPreview));
